(function () {
  if (window.netstepsGiftCardRecipientInit) return;
  window.netstepsGiftCardRecipientInit = true;

  var EMAIL_PATTERN = /^[^\s@]+@[^\s@]+\.[^\s@]{2,}$/;
  var STORAGE_KEY = 'netsteps-gift-card-draft';

  function toIsoDate(date) {
    var month = String(date.getMonth() + 1).padStart(2, '0');
    var day = String(date.getDate()).padStart(2, '0');
    return date.getFullYear() + '-' + month + '-' + day;
  }

  function sendLater(formEl) {
    var selected = formEl.querySelector('[data-gift-card-send-mode]:checked');
    return selected && selected.value === 'later';
  }

  function setDateBounds(sendOn) {
    var today = new Date();
    var max = new Date();
    max.setDate(today.getDate() + 90);
    sendOn.min = toIsoDate(today);
    sendOn.max = toIsoDate(max);
  }

  function getDraftKey(formEl) {
    var productForm = formEl.closest('product-form');
    var productId = productForm && productForm.getAttribute('data-product-id');
    return productId ? STORAGE_KEY + '-' + productId : STORAGE_KEY;
  }

  function saveDraft(formEl) {
    var sender = formEl.querySelector('[data-gift-card-sender]');
    var recipient = formEl.querySelector('[data-gift-card-recipient-name]');
    var email = formEl.querySelector('[data-gift-card-recipient-email]');
    var message = formEl.querySelector('[data-gift-card-message]');
    var sendOn = formEl.querySelector('[data-gift-card-send-on]');
    var payload = {
      sender: sender ? sender.value : '',
      recipient: recipient ? recipient.value : '',
      email: email ? email.value : '',
      message: message ? message.value : '',
      later: sendLater(formEl),
      sendOn: sendOn ? sendOn.value : '',
    };
    try {
      window.sessionStorage.setItem(getDraftKey(formEl), JSON.stringify(payload));
    } catch (error) {}
  }

  function restoreDraft(formEl) {
    var raw;
    try {
      raw = window.sessionStorage.getItem(getDraftKey(formEl));
    } catch (error) {
      return;
    }
    if (!raw) return;
    var payload;
    try {
      payload = JSON.parse(raw);
    } catch (error) {
      return;
    }
    var sender = formEl.querySelector('[data-gift-card-sender]');
    var recipient = formEl.querySelector('[data-gift-card-recipient-name]');
    var email = formEl.querySelector('[data-gift-card-recipient-email]');
    var message = formEl.querySelector('[data-gift-card-message]');
    var laterInput = formEl.querySelector('[data-gift-card-send-mode][value="later"]');
    var nowInput = formEl.querySelector('[data-gift-card-send-mode][value="now"]');
    var sendOn = formEl.querySelector('[data-gift-card-send-on]');
    if (sender && payload.sender) sender.value = payload.sender;
    if (recipient && payload.recipient) recipient.value = payload.recipient;
    if (email && payload.email) email.value = payload.email;
    if (message && payload.message) message.value = payload.message;
    if (payload.later && laterInput) {
      laterInput.checked = true;
    } else if (nowInput) {
      nowInput.checked = true;
    }
    syncSendMode(formEl);
    if (payload.later && sendOn && payload.sendOn) sendOn.value = payload.sendOn;
  }

  function syncSendMode(formEl) {
    var later = sendLater(formEl);
    var dateWrap = formEl.querySelector('[data-gift-card-date-wrap]');
    var sendOn = formEl.querySelector('[data-gift-card-send-on]');
    var timezone = formEl.querySelector('[data-recipient-form-timezone-input]');

    formEl.classList.toggle('netsteps-gift-card-form--later', later);

    if (dateWrap) dateWrap.hidden = !later;

    if (sendOn) {
      sendOn.readOnly = false;
      if (later) {
        sendOn.removeAttribute('disabled');
        sendOn.setAttribute('name', 'properties[Send on]');
        sendOn.required = true;
        setDateBounds(sendOn);
      } else {
        sendOn.required = false;
        sendOn.value = '';
        sendOn.setAttribute('disabled', 'disabled');
        sendOn.removeAttribute('name');
      }
    }

    if (timezone) {
      timezone.disabled = !later;
      if (later) timezone.value = String(new Date().getTimezoneOffset());
    }
  }

  function isValidEmail(value) {
    return EMAIL_PATTERN.test(String(value || '').trim());
  }

  function isFilled(input) {
    return Boolean(input && String(input.value || '').trim());
  }

  function showEmailError(formEl, emailInput, show) {
    var errorEl = formEl.querySelector('[data-gift-card-email-error]');
    var message = emailInput ? emailInput.getAttribute('data-email-error') || '' : '';
    if (emailInput) {
      emailInput.setCustomValidity(show ? message : '');
      emailInput.classList.toggle('is-invalid', show);
    }
    if (errorEl) {
      errorEl.hidden = !show;
      errorEl.textContent = show ? message : '';
    }
  }

  function showFieldError(errorEl, input, show) {
    var message = (input && input.getAttribute('data-name-error')) || '';
    if (input) {
      input.setCustomValidity(show ? message : '');
      input.classList.toggle('is-invalid', show);
    }
    if (errorEl) {
      errorEl.hidden = !show;
      errorEl.textContent = show ? message : '';
    }
  }

  function getFields(formEl) {
    return {
      sender: formEl.querySelector('[data-gift-card-sender]'),
      recipient: formEl.querySelector('[data-gift-card-recipient-name]'),
      email: formEl.querySelector('[data-gift-card-recipient-email]'),
      message: formEl.querySelector('[data-gift-card-message]'),
      sendOn: formEl.querySelector('[data-gift-card-send-on]'),
    };
  }

  function setCopyValue(input, value) {
    if (!input) return;
    var trimmed = String(value || '').trim();
    input.value = trimmed;
    input.disabled = !trimmed;
  }

  function syncOrderProperties(formEl) {
    var fields = getFields(formEl);
    setCopyValue(formEl.querySelector('[data-gift-card-message-shopify]'), fields.message && fields.message.value);
    setCopyValue(formEl.querySelector('[data-gift-card-recipient-name-copy]'), fields.recipient && fields.recipient.value);
    setCopyValue(formEl.querySelector('[data-gift-card-recipient-email-copy]'), fields.email && fields.email.value);
    setCopyValue(
      formEl.querySelector('[data-gift-card-send-on-copy]'),
      sendLater(formEl) && fields.sendOn ? fields.sendOn.value : ''
    );
  }

  function isGiftCardComplete(formEl) {
    var fields = getFields(formEl);
    if (!isFilled(fields.sender) || !isFilled(fields.recipient) || !isValidEmail(fields.email && fields.email.value)) {
      return false;
    }
    if (sendLater(formEl) && fields.sendOn && !fields.sendOn.value) return false;
    return true;
  }

  function revealErrors(formEl) {
    var fields = getFields(formEl);
    var firstInvalid = null;
    var alertEl = formEl.querySelector('[data-gift-card-form-alert]');
    if (!isFilled(fields.sender)) {
      showFieldError(formEl.querySelector('[data-gift-card-sender-error]'), fields.sender, true);
      firstInvalid = firstInvalid || fields.sender;
    }
    if (!isFilled(fields.recipient)) {
      showFieldError(formEl.querySelector('[data-gift-card-recipient-name-error]'), fields.recipient, true);
      firstInvalid = firstInvalid || fields.recipient;
    }
    if (!isValidEmail(fields.email && fields.email.value)) {
      showEmailError(formEl, fields.email, true);
      firstInvalid = firstInvalid || fields.email;
    }
    if (sendLater(formEl) && fields.sendOn && !fields.sendOn.value) {
      firstInvalid = firstInvalid || fields.sendOn;
    }
    if (alertEl) {
      alertEl.hidden = !firstInvalid;
      if (firstInvalid && alertEl.scrollIntoView) {
        alertEl.scrollIntoView({ behavior: 'smooth', block: 'center' });
      }
    }
    return firstInvalid;
  }

  function hideFormAlert(formEl) {
    var alertEl = formEl.querySelector('[data-gift-card-form-alert]');
    if (alertEl) alertEl.hidden = true;
  }

  function clearFieldErrorsIfValid(formEl) {
    var fields = getFields(formEl);
    if (isFilled(fields.sender)) {
      showFieldError(formEl.querySelector('[data-gift-card-sender-error]'), fields.sender, false);
    }
    if (isFilled(fields.recipient)) {
      showFieldError(formEl.querySelector('[data-gift-card-recipient-name-error]'), fields.recipient, false);
    }
    if (isValidEmail(fields.email && fields.email.value)) showEmailError(formEl, fields.email, false);
  }

  function updateGiftCardButtons() {
    document.querySelectorAll('product-form[data-gift-card]').forEach(function (productForm) {
      var giftForm = productForm.querySelector('[data-gift-card-form]');
      if (!giftForm) return;
      var awaiting = productForm.hasAttribute('data-awaiting-size-selection');
      productForm.querySelectorAll('.product-form__btn-wrapper button[name="add"]').forEach(function (button) {
        if (awaiting) return;
        button.disabled = false;
      });
    });
  }

  window.netstepsGiftCardUpdateButtons = updateGiftCardButtons;

  function blockInvalidAdd(event) {
    var button = event.target.closest('product-form[data-gift-card] button[name="add"]');
    if (!button) return;
    var productForm = button.closest('product-form');
    if (!productForm || productForm.hasAttribute('data-awaiting-size-selection')) return;
    var giftForm = productForm.querySelector('[data-gift-card-form]');
    if (!giftForm) return;
    if (isGiftCardComplete(giftForm)) return;
    event.preventDefault();
    event.stopPropagation();
    event.stopImmediatePropagation();
    revealErrors(giftForm);
  }

  function initForm(formEl) {
    restoreDraft(formEl);
    var sendOn = formEl.querySelector('[data-gift-card-send-on]');
    if (sendOn) setDateBounds(sendOn);
    syncSendMode(formEl);
    syncOrderProperties(formEl);
    clearFieldErrorsIfValid(formEl);
    updateGiftCardButtons();

    if (formEl.dataset.giftCardBound === 'true') return;
    formEl.dataset.giftCardBound = 'true';

    formEl.addEventListener('input', function () {
      saveDraft(formEl);
      syncOrderProperties(formEl);
      clearFieldErrorsIfValid(formEl);
      if (isGiftCardComplete(formEl)) hideFormAlert(formEl);
    });
    formEl.addEventListener('change', function () {
      syncSendMode(formEl);
      syncOrderProperties(formEl);
      saveDraft(formEl);
    });
  }

  function initAll() {
    document.querySelectorAll('[data-gift-card-form]').forEach(initForm);
    updateGiftCardButtons();
  }

  document.addEventListener('click', blockInvalidAdd, true);
  document.addEventListener('submit', function (event) {
    var giftForm = event.target.querySelector && event.target.querySelector('[data-gift-card-form]');
    if (!giftForm) return;
    syncOrderProperties(giftForm);
    if (isGiftCardComplete(giftForm)) return;
    event.preventDefault();
    event.stopPropagation();
    revealErrors(giftForm);
  }, true);

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll);
  } else {
    initAll();
  }

  document.addEventListener('shopify:section:load', initAll);
  document.addEventListener('change', function (event) {
    if (!event.target.closest('variant-picker[data-gift-card]')) return;
    window.requestAnimationFrame(initAll);
  });
})();
